// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsListPage_container__1yZOG"};